import { render, staticRenderFns } from "./FieldsBlock.vue?vue&type=template&id=263c5ee6&scoped=true"
import script from "./FieldsBlock.vue?vue&type=script&lang=js"
export * from "./FieldsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263c5ee6",
  null
  
)

export default component.exports